export const PANORAMIC_ORDER_DETAIL_FIELDS = [
    { key: 'p_id', label: 'Sıra Numarası' },
    { key: 'p_albumEbat', label: 'Albüm Ebatı' },
    { key: 'p_albumNumber', label: 'Albüm Sayısı' },
    { key: 'p_familyAlbumEbat', label: 'Aile Albümü Ebat' },
    { key: 'p_familyAlbumNumber', label: 'Aile Albümü (Adet)' },
    { key: 'p_cepAlbumEbat', label: 'Cep Albümü Ebat', hidden: true },
    { key: 'p_cepAlbumNumber', label: 'Cep Albümü (Adet)', hidden: true },
    { key: 'p_albumType', label: 'Albüm Türü' },
    { key: 'p_pageNumber', label: 'Sayfa Sayısı' },
    { key: 'p_coverModel', label: 'Kapak Modeli' },
    { key: 'p_albumOrder', label: 'Albüm Sıralaması' },
    { key: 'p_printingEbat', label: 'Baskı (Ebat)' },
    { key: 'p_tualEbat', label: 'Tual (Ebat)' },
    { key: 'p_description', label: 'Açıklama' },
    { key: 'p_companyMail', label: 'Müşteri Mail Adresi' },
    { key: 'p_orderNumber', label: 'Sipariş Numarası' },
    { key: 'p_companyName', label: 'Firma Adı' },
    { key: 'p_printingEbat2', label: 'Baskı2 (Ebat)' },
    { key: 'p_printingEbat3', label: 'Baskı3 (Ebat)' },
    { key: 'p_tualEbat2', label: 'Tual2 (Ebat)' },
    { key: 'p_tualEbat3', label: 'Tual3 (Ebat)' },
    { key: 'p_brideName', label: 'Gelin & Damat & Bebek İsmi' },
    { key: 'p_eventDate', label: 'Gelin & Damat & Bebek Tarih' },
];

export const SCHOOL_ORDER_DETAIL_FIELDS = [
    { key: 's_id', label: 'Sıra Numarası' },
    { key: 's_albumEbat', label: 'Albüm Ebatı' },
    { key: 's_pageNumber', label: 'Sayfa Sayısı' },
    { key: 's_studentNumber', label: 'Öğrenci Sayısı' },
    { key: 's_calendarEbat', label: 'Takvim Ebatı' },
    { key: 's_calendarNumber', label: 'Takvim Sayısı' },
    { key: 's_description', label: 'Açıklama' },
    { key: 's_companyMail', label: 'Firma Mail Adresi' },
    { key: 's_companyName', label: 'Firma İsmi' },
    { key: 's_orderNumber', label: 'Sipariş Numarası' },
];

export const TUAL_ORDER_DETAIL_FIELDS = [
    { key: 't_id', label: 'Sıra Numarası' },
    { key: 't_ebat', label: 'Tual Ebatı' },
    { key: 't_number', label: 'Tual Sayısı' },
    { key: 't_description', label: 'Açıklama' },
    { key: 't_companyMail', label: 'Firma Mail Adresi' },
    { key: 't_orderNumber', label: 'Sipariş Numarası' },
    { key: 't_companyName', label: 'Firma İsmi' },
];

export const PHOTOBLOCK_ORDER_DETAIL_FIELDS = [
    { key: 'f_id', label: 'Sıra Numarası' },
    { key: 'f_ebat', label: 'Fotoblok Ebatı' },
    { key: 'f_number', label: 'Fotoblok Sayısı' },
    { key: 'f_description', label: 'Açıklama' },
    { key: 'f_companyMail', label: 'Firma Mail Adresi' },
    { key: 'f_orderNumber', label: 'Sipariş Numarası' },
    { key: 'f_companyName', label: 'Firma Maili' },
];

export const PRINTING_ORDER_DETAIL_FIELDS = [
    { key: 'b_id', label: 'Sıra Numarası' },
    { key: 'b_ebat', label: 'Baskı Ebatı' },
    { key: 'b_number', label: 'Baskı Sayısı' },
    { key: 'b_description', label: 'Açıklama' },
    { key: 'b_companyMail', label: 'Firma Mail Adresi' },
    { key: 'b_orderNumber', label: 'Sipariş Numarası' },
    { key: 'b_companyName', label: 'Firma Maili' },
];

const ORDER_DETAIL_FIELDS_BY_NAME = {
    'Panoramik Albüm': PANORAMIC_ORDER_DETAIL_FIELDS,
    'Okul Albüm': SCHOOL_ORDER_DETAIL_FIELDS,
    'Tual': TUAL_ORDER_DETAIL_FIELDS,
    'Fotoblok': PHOTOBLOCK_ORDER_DETAIL_FIELDS,
    'Baskı': PRINTING_ORDER_DETAIL_FIELDS,
};

export function getVisibleOrderDetailFields(orderName, orderData) {
    const fields = ORDER_DETAIL_FIELDS_BY_NAME[orderName] || [];

    return fields.filter((field) => {
        if (field.hidden) {
            return false;
        }

        return orderData && Object.prototype.hasOwnProperty.call(orderData, field.key);
    });
}
